import { SxProps, Theme } from '@mui/material';

type TStyles = {
  title: SxProps<Theme>;
  container: SxProps<Theme>;
  mobileActions: SxProps<Theme>;
  primaryButton: SxProps<Theme>;
  toggleButton: SxProps<Theme>;
  contentWrapper: (inRow?: boolean) => SxProps<Theme>;
  qrWrapper: SxProps<Theme>;
  instructionsList: SxProps<Theme>;
  instructionItem: SxProps<Theme>;
};

export const styles: TStyles = {
  title: {
    textAlign: 'center',
    mb: 2.5,
    fontWeight: 700,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    p: 2.5,
    pt: 0,
  },
  mobileActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.25,
    width: '100%',
    maxWidth: 400,
    alignSelf: 'center',
    mx: 'auto',
    mt: 1.875,
    mb: 2.5,
  },
  primaryButton: {
    width: '100%',
    py: 1.5,
    px: 1.5,
    textAlign: 'center',
    bgcolor: 'common.black',
    color: 'common.white',
    borderRadius: 1,
    fontSize: '14px',
    fontFamily: "'Nunito Sans', sans-serif",
    textTransform: 'none',
    mx: 'auto',
    '&:hover': { bgcolor: 'common.black', opacity: 0.9 },
  },
  toggleButton: {
    width: '100%',
    py: 1,
    px: 1.5,
    textAlign: 'center',
    color: 'common.black',
    fontSize: '14px',
    textDecoration: 'underline',
    textTransform: 'none',
    mx: 'auto',
    '&:hover': { bgcolor: 'transparent', opacity: 0.8 },
  },
  contentWrapper: (inRow = false) => ({
    width: '100%',
    maxWidth: inRow ? 'unset' : 600,
    display: inRow ? 'flex' : 'block',
    alignItems: 'center',
  }),
  qrWrapper: {
    display: 'flex',
    justifyContent: 'center',
    my: 2.5,
  },
  instructionsList: {
    listStylePosition: 'inside',
    textAlign: 'left',
    maxWidth: 600,
    mt: 2.5,
    mb: 0,
    pl: 0,
    lineHeight: 1.5,
  },
  instructionItem: {
    mb: 1.25,
  },
};
